// extracted by mini-css-extract-plugin
export default {"modal":"AddUser_modal__r-ACw","fadeIn":"AddUser_fadeIn__h9edV","modalContent":"AddUser_modalContent__THJun","slideIn":"AddUser_slideIn__b4D1O","buttons":"AddUser_buttons__5y4rI"};